// 预约状态
let ReservationStatus = {
  RESERVATED: "0",		// 待审核
  AUDITED: "1",		    // 已审核
  COMPLETED: "2",		    // 已完成
  REFUSED: "3",		    // 已拒绝
  INVALID: "4",		    // 已作废
};

// 短信发送状态
let SmsSendStatus = {
  no_send: "0",       // 未发送
  send_fail: "1",      // 发送失败(等待重发)
  send_success: "2",  // 发送成功
  send_cacel: "3"      // 作废
}

// 过磅记录上传状态
let uploadStatus = {
  first_success: "1",      // 一次过磅上传成功
  second_success: "2",     // 二次过磅上传成功
  first_fail: "4",       // 一次过磅上传失败
  second_fail: "5",       // 二次过磅上传失败
}

// 角色类型
let RoleType = {
  SUPER_ADMIN: -1,    // 超级管理员
  ADMIN: 1,            // 管理员
  SUPPLIER: 2,         // 供应商
  PURCHASER: 3,        // 司磅员
  BUSINESS: 4,         // 客户
  SALE_MAN: 5,         // 销售业务员
  SALE_MANAGER: 6,     // 销售主管
  FINANCE: 7,          // 财务
  PURCH: 8,            // 采购部
}

// 材料/倒料 操作类型
let OperTypeList = [
  { "id": "1", "name": "先过重车" },
  { "id": "2", "name": "先过空车" }
]

let ytBaseInfoType = {
  weigh_type_waste: "301",	// 材料过磅类型
  weigh_type_veer: "302",		// 倒料过磅类型
  place_get_out: "303",		// 倒料倒入倒出地点
}


// 业务类型
let BusinessTypeId = {
  sell: 101,		// 销售
  purchase: 102,		// 采购
  waste: 103,		// 材料
  veer: 104,		    // 倒料
};

// 扣杂类型
let deductType = {
  ton: "T",         // 吨
  percent: "%",     // 百分比
}

let deductTypeList = [
  { "id": "T", "name": "吨" },
  { "id": "%", "name": "百分比" },
]


let OrderStatus = {
  SAVED: "-1",             // 已保存
  WAIT_AUDIT: "0",         // 待审核(提交)
  XS_AUDITED: "1",         // 销售已审核
  AUDITED: "2",            // 财务已审核
  CANCELED: "3",           // 已作废
  XS_REFUSE: "4",          // 销售审核不通过
  REFUSE: "5",             // 财务审核不通过
  FINISHED: "6",           // 已完结
  /* 	WAIT_INVOICE:"7",       // 待开票
    INVOICED:"8",           // 已开票
    INVOICE_FINISHED:"9",   // 已收票 */
}


const bizList = [{ "id": "102", "name": "原材料" }, { "id": "103", "name": "材料" }, { "id": "104", "name": "倒料" }, { "id": "101", "name": "销售" }]
//const allBizList = [{"id":"101","name":"销售"},{"id":"102","name":"原材料"}, {"id":"103","name":"材料"},{"id":"104","name":"倒料"}]

const orderStatusList = []
const transportTypeList = []
const paymentTypeList = []

let baseApiPath = "http://g25286736.gicp.net:8083/"

var curUrl = window.location.href;
var url = window.location.search.match(/url=([^&]+)/);
if (url && url.length > 1) {
  url = decodeURIComponent(url[1]);
} else {
  //8000
  if (curUrl.indexOf("localhost") != -1) {
    baseApiPath = "http://localhost:8000/";
  } else {
    baseApiPath = "http://" + window.location.host + "/"
  }
  /*  if (curUrl.indexOf("192.168.0.30") != -1){
     baseApiPath = "http://192.168.0.30:8083/";
   } */
}
// 报表测试
let jasperTestUrl = baseApiPath + "api/materiel/jasperTest?type="

// 图片显示接口地址
let imgApiUrl = baseApiPath + "api/common/showImgById?id="

// 文件下载接口
let downloadUrl = baseApiPath + "api/attachment/downFile?id="

// 模板下载路径
let downLoadMouldUrl = baseApiPath + "api/user/downLoadMould?fileName="

// 用户导出下载
let downloadUserUrl = baseApiPath + "api/user/exportUserExcel?fileName="
// 用户导入
let importUserUrl = baseApiPath + "api/user/importUserExcel"

let importMaterUrl = baseApiPath + "api/materiel/importMaterielExcel"

let importBusinessUrl = baseApiPath + "api/corpBusiness/importCorpBusinessExcel"
let importSupplierUrl = baseApiPath + "api/corpSupplier/importCorpSupplierExcel"
let importLogisticsUrl = baseApiPath + "api/corpLogistics/importCorpLogisticsExcel"
let importEscortUrl = baseApiPath + "api/escort/importEscortExcel"
let importDriverUrl = baseApiPath + "api/driver/importDriverExcel"
let importCardUrl = baseApiPath + "api/card/importCardExcel"

// 称重导出下载
// api/weighing/exportWeighingExcel?fileName=
let downloadWeighingUrl = baseApiPath + "api/weighing/exportWeighingExcel?fileName="

let downloadxsWeighingUrl = baseApiPath + "api/logistics/xsdetils?fileName="

let downloadreceiptUrl = baseApiPath + "api/receipt/exportOrderReceiptExcel?fileName="


let downloadStandDetailUrl = baseApiPath + "api/weighing/exportStandDetailExcel?fileName="

let downloadStandStatisticVoUrl = baseApiPath + "api/weighing/exportStandStatisticVoExcel?fileName="

let downloadReportVoUrl = baseApiPath + "api/weighing/exportReportVoExcel?fileName="

let downloadCorpBusinessUrl = baseApiPath + "api/corpBusiness/exportCorpBussinessExcel?fileName="

let downloadCorpSupplierUrl = baseApiPath + "api/corpSupplier/exportCorpSupplierExcel?fileName="

let downloadCorpLogisticsUrl = baseApiPath + "api/corpLogistics/exportCorpLogisticsExcel?fileName="

let downloadCardUrl = baseApiPath + "api/card/exportCardExcel?fileName="

let downDriverUrl = baseApiPath + "api/driver/exportDriverExcel?fileName="

let downEscortUrl = baseApiPath + "api/escort/exportEscortExcel?fileName="

// 化验导出下载
let downloadAssayUrl = baseApiPath + "api/assay/exportAssayExcel?fileName="

// 物流记录导出下载
let downloadLogisticsUrl = baseApiPath + "api/logistics/exportLogisticsExcel?fileName="


// 收发卡导出下载
let downloadGrantCardUrl = baseApiPath + "api/grantCard/exportGrantCardExcel?fileName="

// 文件上传接口
let uploadUrl = baseApiPath + "api/attachment/upload"

// 预约记录导出下载
let downloadReservationUrl = baseApiPath + "api/reservation/exportReservationExcel?fileName="

// 装卸记录导出下载
let downloadLoadVehicleUrl = baseApiPath + "api/loadVehicle/exportLoadVehicleExcel?fileName="
let TYPE_CODE = {
  LOGISTICS_RESERVATION_STATUS: "logistics_reservation_status",

  MATERIEL_TYPE: "basic_factory_load_port_materiel_type",
  MATERIEL_STATUS: "logistics_materiel_status",

  LOGISTICS_WEIGHING_FROM: "logistics_weighing_from",
  LOGISTICS_WEIGHING_EXPLAIN: "logistics_weighing_explain",
};


let Regex = {
  "telephone": /^(((13[0-9])|(15[0-9])|(14[0-9])|(17[0-9])|(18[0-9])|(19[0-9]))+\d{8})$/,
  "idCardNum": /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/,
  "vehicleNo": /(^[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领A-Z]{1}[A-Z]{1}[A-Z0-9]{4}[A-Z0-9学警港澳]{1}$)/
};

function excuteSetTitle() {
  if ($(".ant-table-tbody > tr > td").length > 0) {
    setTitle()
  } else {
    setTimeout(excuteSetTitle, 100);
  }
}
function setTitle() {
  $(".ant-table-tbody > tr > td").each(function () {
    $(this).attr("title", $(this).text());
    $(this).css("cursor", 'pointer');
    // let key = $(this).parent('tr').attr('data-row-key')
    // console.log("key="+key+"文本="+$(this).text())
  });
}
export default {
  ReservationStatus: ReservationStatus,
  SmsSendStatus: SmsSendStatus,
  TYPE_CODE: TYPE_CODE,
  RoleType: RoleType,
  OperTypeList: OperTypeList,
  Regex: Regex,
  jasperTestUrl: jasperTestUrl,
  imgApiUrl: imgApiUrl,
  downloadUrl: downloadUrl,
  downloadUserUrl: downloadUserUrl,
  importUserUrl: importUserUrl,
  importMaterUrl: importMaterUrl,
  importBusinessUrl: importBusinessUrl,
  importSupplierUrl: importSupplierUrl,
  importLogisticsUrl: importLogisticsUrl,
  importCardUrl: importCardUrl,
  downLoadMouldUrl: downLoadMouldUrl,
  downloadWeighingUrl: downloadWeighingUrl,
  downloadxsWeighingUrl: downloadxsWeighingUrl,
  downloadreceiptUrl: downloadreceiptUrl,
  downloadStandDetailUrl: downloadStandDetailUrl,
  downloadStandStatisticVoUrl: downloadStandStatisticVoUrl,
  downloadReportVoUrl: downloadReportVoUrl,
  downloadCorpBusinessUrl: downloadCorpBusinessUrl,
  downloadCorpSupplierUrl: downloadCorpSupplierUrl,
  downloadCorpLogisticsUrl: downloadCorpLogisticsUrl,
  downloadAssayUrl: downloadAssayUrl,
  downloadLogisticsUrl: downloadLogisticsUrl,
  downloadGrantCardUrl: downloadGrantCardUrl,
  downloadReservationUrl: downloadReservationUrl,
  downloadLoadVehicleUrl: downloadLoadVehicleUrl,
  downDriverUrl: downDriverUrl,
  downEscortUrl: downEscortUrl,
  downloadCardUrl: downloadCardUrl,
  importEscortUrl: importEscortUrl,
  importDriverUrl: importDriverUrl,
  uploadUrl: uploadUrl,
  BusinessTypeId: BusinessTypeId,
  bizList: bizList,
  ytBaseInfoType: ytBaseInfoType,
  uploadStatus: uploadStatus,
  deductType: deductType,
  deductTypeList: deductTypeList,
  excuteSetTitle: excuteSetTitle,

  OrderStatus: OrderStatus,
  orderStatusList: orderStatusList,
  transportTypeList: transportTypeList,
  paymentTypeList: paymentTypeList,


  logistics_status_no_finish: '-999', // 物流状态未完成

  //  =====  系统功能区配置  =====
  // 是否开启“显示Alert”功能  true 是  false 否
  hasAlert: false,
  // 是否开启黑名单功能  true 是  false 否
  blackListOpen: false,

  // 单价是否关联客户  true 是  false 否
  priceLinkBusiness: false,
  // 全局开启表格边框线
  globlaBordered: true,
  // 车号长度限制
  vehicleNoLength: 10,
  // 系统设置
  settings: {}


}